export enum ProspectType {
  Residential = 0,
  CondensedFlowGoogleAuthenticated = 1,
  SunCentralSignUp = 2,
  CondensedFlowWaitlist = 3
}

export const ProspectTypeStrings: any = {
  Residential: '0',
  CondensedFlowGoogleAuthenticated: '1',
  SunCentralSignUp: '2',
  CondensedFlowWaitlist: '3'
};
